import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../services/authentication.service';

@Component({
  selector: 'app-profile-password',
  templateUrl: './profile-password.component.html',
  styleUrls: ['./profile-password.component.scss']
})
export class ProfilePasswordComponent {
  oldPassword = '';
  newPassword = '';
  confirmPassword = '';
  errorMessage: string = null;
  errorMsgForShow: String =null;
  isShowPassword = {
    old : false,
    new : false,
    confirm : false
  };

  constructor(private apiService: ApiService, private router: Router,
              private authService: AuthenticationService,
              private translate: TranslateService) {
  }

  submit() {
    this.errorMessage = null;
    if (this.translate.currentLang !== 'en') {
      if (this.newPassword.length === 0) {
        this.errorMessage = 'โปรดกรอกรหัสผ่าน';
      } else {
        if (this.confirmPassword !== this.newPassword) {
          this.errorMessage = 'รหัสผ่านไม่ตรงกัน';
        } else {
          this.apiService.updatePassword({
            old_password: this.oldPassword,
            new_password: this.newPassword
          }).subscribe(
            () => this.router.navigate(['']),
            error => {
              this.checkErrorMsg(error);
            }
          );
        }
      }
    } else {
      if (this.newPassword.length === 0) {
        this.errorMessage = 'Please fill Password';
      } else if (this.confirmPassword !== this.newPassword) {
        this.errorMessage = 'Passwords do not match.';
      } else {
        this.apiService.updatePassword({
          old_password: this.oldPassword,
          new_password: this.newPassword
        }).subscribe(
          () => {
            localStorage.removeItem('require_to_change_password');
            if (this.authService.isAccountant()) {
              this.router.navigate(['/search']);
            } else {
              this.router.navigate(['']);
            }
          },
          error => {
            this.checkErrorMsg(error);
          }
        );
      }
    }

  }

  showPassword(field){
    this.isShowPassword[field] = !this.isShowPassword[field]
  }

  checkErrorMsg(error) {
    this.errorMsgForShow = this.apiService.getErrorMessage(error);
    if (this.translate.currentLang === 'en') {
      this.errorMessage = this.errorMsgForShow[0]
    } else {
      this.errorMessage = this.errorMsgForShow[1]
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts